export const filterOperators = {
  // eslint-disable-next-line eqeqeq
  eq: (a, b) => a == b,
  seq: (a, b) => a === b, // strict equality
  // eslint-disable-next-line eqeqeq
  neq: (a, b) => a != b,
  sneq: (a, b) => a !== b, // strict inequality
  lt: (a, b) => a < b,
  lte: (a, b) => a <= b,
  gt: (a, b) => a > b,
  gte: (a, b) => a >= b,
  exists: (a) => !!a,
  notExists: (a) => !a,
  missing: (a) => !a,
  isNull: (a) => a === null,
  isUndefined: (a) => a === undefined,
  notNull: (a) => a !== null,
  isDefined: (a) => a !== undefined,
  isNullOrUndefined: (a) => a === null || a === undefined,
  notNullOrUndefined: (a) => a !== null && a !== undefined,
  hasValue: (a) => a !== null && a !== undefined,
  sw: (a, b) => a?.toString()?.startsWith(b?.toString()),
  ew: (a, b) => a?.toString()?.endsWith(b?.toString()),
  contains: (a, b) => a?.toString()?.includes(b?.toString()),
  in: (value, array, comparator = 'eq') => Array.isArray(array) ? array.some(x => filterOperators[comparator](value, x)) : false
}
